<template>
  <v-container
    id="component-events-view"
    fluid
    tag="section"
  >
    <cumulus-edit-dialog
      ref="editComponentEvent"
      v-model="dialogEditComponentEvent"
      icon="$edit"
      :title="$t('event_info')"
      :max-width="700"
      :loading="loading"
      can-delete
      @save="saveComponentEvent"
      @remove="deleteComponentEvent"
      @escape="closeDialogEditComponentEvent"
    >
      <template v-slot:editform>
        <edit-component-event
          :component-event="editedItem"
        />
      </template>
    </cumulus-edit-dialog>

    <material-card
      icon="$events"
      icon-small
      color="accent"
      :title="page_title"
    >
      <template v-slot:title2>
        <div class="text-h5">
          <tooltip-btn
            icon="$back"
            tooltip="components"
            @click="back"
          />
        </div>
      </template>
      <v-card-title>
        <v-btn
          v-show="editor"
          v-shortkey.once="['f2']"
          :disabled="!editor"
          color="primary"
          class="mb-2"
          @shortkey="showDialogEditComponentEvent({ })"
          @click="showDialogEditComponentEvent({ })"
        >
          {{ $t('new_item',{ item: $t('component_event') }) }}
        </v-btn>
        <v-row class="ma-0">
          <v-spacer v-if="!$vuetify.breakpoint.mdAndDown" />
          <v-text-field
            v-model="search"
            append-icon="$search"
            class="ml-auto"
            hide-details
            :label="$t('search_records')"
            single-line
          />
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="computed_headers"
          :items="items"
          :loading="loading"
          :loading-text="$t('loading')"
          :options.sync="options"
          :server-items-length="total"
          :footer-props="footerProps"
        >
          <template #item.event_type="{item}">
            {{ $t( 'types.'+item.event_type.name) }}
          </template>
          <template #item.event_start="{item}">
            {{ item.event_start | dateFormat }}
          </template>
          <template #item.event_end="{item}">
            {{ item.event_end | dateFormat }}
          </template>
          <template #item.actions="{item}">
            <v-btn
              v-if="item.storage_id !== null"
              :href="documentStorageUrl(item)"
              icon
              target="_blank"
            >
              <v-icon>
                {{ '$show' }}
              </v-icon>
            </v-btn>
            <tooltip-btn
              v-for="(action, i) in actions"
              :key="i"
              :show="!action.disable"
              :color="action.color"
              :icon="action.icon"
              :tooltip="action.tooltip"
              @click="action.func(item)"
            >
              <v-icon v-text="action.icon" />
            </tooltip-btn>
          </template>
        </v-data-table>
      </v-card-text>
    </material-card>
  </v-container>
</template>

<script>
  // Utilities
  import { get, call, sync } from 'vuex-pathify'
  import EditComponentEvent from '@/layouts/default/edit/ComponentEvent'

  export default {
    name: 'ComponentEvents',
    components: { EditComponentEvent },
    data () {
      return {
        items: [],
        // table
        footerProps: {
          itemsPerPageOptions: [10, 20, 25, 50, 100],
        },
        total: 0,
        timer: null,
        dialogEditComponentEvent: false,
        editedItem: {},
        component: null,
      }
    },
    computed: {
      loading: get('app/loading'),
      profile: get('auth/profile'),
      options: sync('componentEvent/options'),
      search: sync('componentEvent/search'),
      prevRoute: sync('componentEvent/prevRoute'),
      headers () {
        return [
          {
            text: this.$t('fields.event_type_id'),
            sortable: false,
            value: 'event_type',
          },
          {
            text: this.$t('fields.event_start'),
            sortable: false,
            value: 'event_start',
          },
          {
            text: this.$t('fields.event_end'),
            sortable: false,
            value: 'event_end',
          },
          {
            text: this.$t('fields.limit_counter_takeoff'),
            sortable: false,
            value: 'limit_counter_takeoff',
          },
          {
            text: this.$t('fields.limit_counter_flight'),
            sortable: false,
            value: 'limit_counter_flight',
          },
          {
            text: this.$t('fields.limit_counter_engine'),
            sortable: false,
            value: 'limit_counter_engine',
          },
          {
            text: this.$t('actions'),
            value: 'actions',
            sortable: false,
            align: 'right',
          },
        ]
      },
      actions () {
        return [
          { color: 'edit', icon: '$edit', tooltip: 'tooltip_edit', func: this.showDialogEditComponentEvent, disable: !this.editor },
        ]
      },
      page_title () { return this.$t('component_events') },
      editor () { return this.profile.can['component-edit'] },
      computed_headers () { return this.headers.filter(h => h.hide_small !== this.$vuetify.breakpoint.mdAndDown) },
    },
    watch: {
      search: {
        handler () {
          if (this.timer) {
            clearTimeout(this.timer)
            this.timer = null
          }
          this.timer = setTimeout(() => {
            this.options.page = 1
            this.load()
          }, 800)
        },
        deep: true,
      },
      options: {
        handler () {
          this.load()
        },
        deep: true,
      },
      country: {
        handler () {
          this.load()
        },
        deep: true,
      },
    },
    mounted () {
      this.component_id = parseInt(this.$route.params.id)
      this.getComponent({ id: this.component_id }).then(response => {
        this.component = response
        console.log(this.component)
      })
    },
    methods: {
      getList: call('componentEvent/search'),
      getComponent: call('component/fetch'),
      insertEditedItem: call('componentEvent/insert'),
      updateEditedItem: call('componentEvent/update'),
      deleteEditedItem: call('componentEvent/delete'),

      async load () {
        try {
          const { sortBy, sortDesc, page, itemsPerPage } = this.options
          await this.getList({
            page: page,
            per_page: itemsPerPage,
            sort: {
              field: sortBy,
              order: sortDesc,
            },
            search: this.search,
            component_id: this.component_id,
          }).then(response => {
            this.items = response.data
            this.total = response.total
          }).catch(e => {
            console.log(e)
          })
        } catch (e) {
        }
      },
      showDialogEditComponentEvent (item) {
        if (!item.id) {
          this.editedItem = Object.assign({}, {
            component_id: this.component_id,
            counter_takeoff: 0,
            counter_flight: 0,
            counter_engine: 0,
          })
        } else {
          this.editedItem = Object.assign({}, item)
        }

        this.editedItem.component = this.component

        if (item.event_start) {
          this.editedItem.event_start = item.event_start // moment(item.event_start).format('YYYY-MM-DD HH:mm')
        }
        if (item.event_end) {
          this.editedItem.event_end = item.event_end // moment(item.event_end).format('YYYY-MM-DD HH:mm')
        }
        this.dialogEditComponentEvent = true
      },
      closeDialogEditComponentEvent () {
        this.dialogEditComponentEvent = false
        this.load()
      },
      async saveComponentEvent () {
        if (!this.editedItem.id) {
          await this.insertEditedItem(this.editedItem).then(response => {
            this.closeDialogEditComponentEvent()
          }).catch(e => {
            this.$refs.editComponentEvent.setErrors(e)
          })
        } else {
          await this.updateEditedItem(this.editedItem).then(response => {
            this.closeDialogEditComponentEvent()
          }).catch(e => {
            this.$refs.editComponentEvent.setErrors(e)
          })
        }
      },
      async deleteComponentEvent () {
        this.deleteEditedItem(
          this.editedItem,
        ).then(response => {
          this.items.splice(this.items.indexOf(this.editedItem), 1)
          this.closeDialogEditComponentEvent()
        }).catch(e => {
          console.log(e)
        })
      },
      back () {
        // console.log('this prevRoute' + this.prevRoute)
        this.$router.push(this.prevRoute).catch(() => {})
      },
      documentStorageUrl (componentEvent) {
        // return 'data:image/jpeg;base64,' + this.user.avatar.image
        return process.env.VUE_APP_API_URL + '/api/storage/' + componentEvent.storage_id
      },
    },
    beforeRouteEnter (to, from, next) {
      next(vm => {
        vm.prevRoute = from
      })
    },
  }
</script>
